import { makeStyles } from '@mui/styles';
import { COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    color: COLOR_PURPLE,
    fontSize: 18,
    textAlign: 'center',
    lineHeight: 1.2,
  },
  mainBoxContent: {
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: 6,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(4, 2),
  },
  textReasons: {
    fontSize: 15,
    color: COLOR_PURPLE,
  },
  list: {
    padding: theme.spacing(0),

    '& li': {
      fontSize: 14,
      paddingBottom: theme.spacing(1),
    },
  },
  mainForm: {
    boxShadow: '0px 3px 6px #00000029',
    border: '1px solid #EEEEEE',
    borderRadius: 6,
    padding: theme.spacing(0, 1.5),
    maxWidth: '100%',
  },
  inputTextName: {
    fontWeight: 'bold',
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(2),
    fontSize: 15,

    '& span': {
      color: '#F01C10',
    },
  },
}));
